import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PositionErrors } from '../models/position-errors.model';

@Injectable()
export class AutofillLocationService {
  private readonly geoOptions: PositionOptions = {
    enableHighAccuracy: true,
    /* 
    The property enableHighAccuracy is a boolean that indicates the application would like to receive the best possible results. 
    Note that this can result in slower response times or increased power consumption
    */
  };

  getCurrentLocation(): Observable<GeolocationPosition> {
    return new Observable((observer) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            observer.next(position);
            observer.complete();
          },
          (error) => observer.error(error),
          this.geoOptions,
        );
      } else {
        observer.error({
          code: PositionErrors.PositionUnavailable,
          message: 'Geolocation is not supported by this browser.',
        });
      }
    });
  }
}
